import React from 'react'
import { CloseCircle, TickCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Modal from '../../Modal'

import useStyles from '../AreYouSureModal/styles'

const VerificationModal = ({ name, onClose, onAccept, ...props }) => {
  const theme = useTheme()
  const classes = useStyles()

  return (
    <Modal open onClose={onClose} {...props}>
      <div className={classes.root}>
        <div className={classes.title}>
          Are you sure you want to verify this person is {name}?
        </div>

        <div>
          <div className={classes.question}>
            <div>
              Once they are verified, the conversation will be marked as such
              and personal information can be shared with them.
            </div>

            <div>
              Only perform this action if you have done required due diligence.
            </div>
          </div>

          <div className={classes.options}>
            <div className={classes.buttonText}>
              <span onClick={onClose} className='button'>
                <CloseCircle
                  size={theme.size.base}
                  className={classes.iconNo}
                />{' '}
                Cancel
              </span>
            </div>

            <div className={classes.buttonText}>
              <span onClick={onAccept} className='button'>
                <TickCircle
                  size={theme.size.base}
                  className={classes.iconYes}
                />{' '}
                Verify
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default VerificationModal
